module.exports = __webpack_public_path__ + "static/media/limericktwentythirty.7c303ba9.png";